import { flow, types, getEnv } from "mobx-state-tree";

import { Endpoint, endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";
import { CustomProperty, emptyCustomProperty } from './ProjectPropertyStorage';
import { permissionsService } from "../authorization/UserPermissionsService";
import { ViewOrganizationProjectProperties } from "../authorization/Permissions";

const CurrentProjectPropertyModel = types.model({
  projectPropertyId: types.frozen<number>(),
  currentProjectProperty: types.optional(types.frozen<CustomProperty>(), emptyCustomProperty),
})

export const CurrentProjectPropertyStorageModel = types
  .compose(CurrentProjectPropertyModel, StorageModel)
  .named("CurrentProjectPropertyStorage")
  .actions((self) => {
    return {
      mapResponse(response: CustomProperty) {
        const projectProperty = response as CustomProperty;
        self.currentProjectProperty = projectProperty;
      },
      deleteProperty: flow(function* deleteProperty() {
        const endpoint = endpoints.get("custom_project_single_property");
        endpoint.routeParams = [self.projectPropertyId];
        yield getEnv(self).api.delete(endpoint);
      }),
    }
  })
  .views((self) => ({
    get projectPropertyIsLoaded() {
      return self.currentProjectProperty.id > 0;
    },

    get endpoint() {
      const endpoint: Endpoint = endpoints.get("custom_project_single_property");
      endpoint.routeParams = [self.projectPropertyId];
      return endpoint;
    },

    get canUserViewProjectProperty() {
      return (
        permissionsService.userHasPermissionTo(ViewOrganizationProjectProperties)
      );
    }
  }))
  .views((self) => ({
    get canLoadItems() {
      return self.canUserViewProjectProperty && self.projectPropertyId > 0;
    },
    get isLoading() {
      return !self.projectPropertyIsLoaded;
    }
  }))
